export const MANUAL_PAYMENT_STATUSES = {
  pending: {label: "در انتظار تایید", className: "border-amber-200 bg-amber-50 text-amber-800"},
  success: {label: "پرداخت موفق", className: "border-emerald-200 bg-emerald-50 text-emerald-800"},
  failure: {label: "پرداخت ناموفق", className: "border-rose-200 bg-rose-50 text-rose-800"},
};

export const MANUAL_PAYMENT_ATTEMPT_KEY = "manual-payment-submission-attempt";

export function currentPaymentRole(data) {
  return data?.roleList?.find(role => String(role.id) === String(data.role_id))?.title || "";
}

export function manualPaymentPayload(form) {
  const personId = Number(form.personId);
  const destinationAccountId = Number(form.destinationAccountId);
  if (!Number.isSafeInteger(personId) || personId <= 0) throw new Error("انتخاب کاربر الزامی است.");
  if (!Number.isSafeInteger(destinationAccountId) || destinationAccountId <= 0) throw new Error("حساب مقصد را انتخاب کنید.");
  const digits = String(form.amount).trim()
    .replace(/[۰-۹]/g, digit => "۰۱۲۳۴۵۶۷۸۹".indexOf(digit))
    .replace(/[٠-٩]/g, digit => "٠١٢٣٤٥٦٧٨٩".indexOf(digit))
    .replace(/[,٬]/g, "");
  const amount = Number(digits);
  if (!/^\d+$/.test(digits) || !Number.isSafeInteger(amount) || amount <= 0) {
    throw new Error("مبلغ باید یک عدد صحیح و مثبت بر حسب ریال باشد.");
  }
  const reference = (form.reference || "").trim();
  const description = (form.description || "").trim();
  if (Array.from(reference).length > 100) throw new Error("مرجع واریزی نباید بیش از ۱۰۰ نویسه باشد.");
  if (Array.from(description).length > 4000) throw new Error("توضیحات نباید بیش از ۴۰۰۰ نویسه باشد.");
  return {
    person_id: personId,
    destination_account_id: destinationAccountId,
    amount,
    payment_method: "card_to_card",
    manual_reference: reference,
    description,
  };
}

export function newPaymentKey() {
  const browserCrypto = window.crypto;
  if (browserCrypto?.randomUUID) return browserCrypto.randomUUID();
  if (browserCrypto?.getRandomValues) {
    const bytes = browserCrypto.getRandomValues(new Uint8Array(16));
    return Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");
  }
  throw new Error("امکان ثبت درخواست در این مرورگر فراهم نیست. مرورگر را به‌روزرسانی کنید.");
}

export function submissionAttempt(payload, previous, makeKey = newPaymentKey) {
  const fingerprint = JSON.stringify(payload);
  if (previous?.fingerprint === fingerprint && /^[A-Za-z0-9._:-]{1,64}$/.test(previous.key || "")) return previous;
  return {fingerprint, key: makeKey()};
}

export function formatManualPaymentDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("fa-IR", {dateStyle: "short", timeStyle: "short", timeZone: "Asia/Tehran"}).format(date);
}
